export const GUARD_PCT = 0.25;
export const TARGET_LOSS_RUN = 7;
export const RECOVERY_PROFIT = 0.05;
export const WIN_RATIO = 0.886; // Deriv pays $0.66 on a $0.35 win → net +88.6%
// One win clears everything lost in the series + 5%, then play returns to base stake.
export const recoveryStake = (base, hole) => (hole <= 0.01 ? base : Math.max(base, Math.ceil((hole * (1 + RECOVERY_PROFIT) / WIN_RATIO) * 100) / 100));
// How many losses in a row the balance can absorb while still affording the next recovery stake.
export function survivableLosses(base, balance) {
  let hole = 0, losses = 0;
  while (losses < 30) {
    const st = recoveryStake(base, hole);
    if (hole + st > balance) break;
    hole += st;
    losses += 1;
  }
  return Math.max(0, losses - 1);
}
// Largest base stake (min $0.35) that survives TARGET_LOSS_RUN losses and still places the winning stake.
export function safeBaseFor(balance) {
  let lo = 0.35, hi = Math.max(0.35, balance);
  if (survivableLosses(lo, balance) < TARGET_LOSS_RUN) return 0.35;
  for (let i = 0; i < 30; i++) {
    const mid = (lo + hi) / 2;
    if (survivableLosses(mid, balance) >= TARGET_LOSS_RUN) lo = mid; else hi = mid;
  }
  return Math.floor(lo * 100) / 100;
}

